import Header from './Header'

const HeaderContainer = (props: { hideBorder?: boolean }) => {
  return (
    <div
      class={`z-50 ${
        !props.hideBorder ? 'border-b border-b-cosplay-gray-100' : ''
      } fixed w-full bg-main`}
    >
      <div class="mx-3 md:px-5 xl:px-6 2xl:px-6 ">
        <Header />
      </div>
    </div>
  )
}

export default HeaderContainer
